import { ref, watch, computed } from '@vue/composition-api'
import client from '../client'

import { useUtils } from '@core/libs/i18n'
                
export default function useList(root) {
  const { t } = useUtils()
  const refListTable = ref(null)

  const tableColumns = [
    { key: 'name', sortable: false, label: t('Name')},
    { key: 'camp_leave', sortable: false, label: t('Camp Leave')},
    { key: 'camp_back', sortable: false, label: t('Camp Back')},
    { key: 'actions',label:t('actions') },
  ]

  const filter = ref({})
  const perPage = ref(10)
  const total = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const requestStatus = ref(false)

  const dataMeta = computed(() => {

    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: total.value,
    }
  })

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery ], () => {
    filter.value = {
      ...(searchQuery.value && {q: searchQuery.value})
    }
    refetchData()
  })

  const fetch = (ctx, callback) => {

    requestStatus.value = true

    client.fetch({
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.data
        const meta = response.data.data.meta
        callback(data)
        total.value = meta.total
      })
      .catch(e => {
        requestStatus.value = false
        console.log(e)
      })
  }


  const remove = (id) => {
    root.$swal({
      title: root.$i18n.t("Are You Sure"),
      text: root.$i18n.t("Do you want to delete this item?"),
      showCancelButton: true,
      confirmButtonText: root.$i18n.t('Delete'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        requestStatus.value = true
        client.delete(id).then(_ => refetchData()).catch(reason => console.log(reason))
      }
    })
  }

  return {

    fetch,
    tableColumns,
    perPage,
    currentPage,
    total,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    remove,
    requestStatus,
    refetchData,

  }
}
